exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".workflow-panel {\n  height: 100%;\n  -ms-flex-align: center;\n      -ms-grid-row-align: center;\n      align-items: center; }\n\n.workflow-panel__main {\n  width: 100%;\n  height: 100%;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-align: center;\n      -ms-grid-row-align: center;\n      align-items: center; }\n\n.workflow-panel__buttons {\n  -ms-flex-positive: 0;\n      flex-grow: 0; }\n  .workflow-panel__buttons > * {\n    margin-right: 10px;\n    min-width: unset; }\n    .workflow-panel__buttons > *:last-child {\n      margin-right: 0; }\n\n.workflow-panel--same-size-buttons .button {\n  width: 96px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/workflow_panel/index.scss
// module id = 2857
// module chunks = 69